
import { Vue } from "vue-class-component";
import StorageService from "../../services/StorageService";
import ApiService from "../../services/ApiService";
import { useStore } from "vuex";

export default class NavigationBar extends Vue {
  private storageService = new StorageService();
  user: any = null;
  portalMessages: any = null;
  messages: any = null;
  unreadMessages = [];
  globalStore = useStore();

  apiService: any = new ApiService();

  async created() {
    this.user = this.storageService.getUser();
    this.portalMessages = this.getUserPortalMessages();
    this.messages = await this.apiService.getMessages(this.user.patientsId);
    this.unreadMessages = this.messages.filter((obj: { readAt: null, senderUsersId: number }) => obj.readAt == null && obj.senderUsersId != this.user.usersId)
    this.globalStore.commit('setUnreadMessages', this.unreadMessages.length)
  }

  getUserPortalMessages() {
    return this.user.portalMessages;
  }

  get getUnreadMessages() {
    return this.globalStore.getters.getUnreadMessages;
  }
}
